import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * SectionHeader - A reusable atom component for displaying a header label
 * 
 * @param {Object} props
 * @param {string} props.label - Text to display in the header
 * @param {Object} props.sx - Additional Box styling overrides
 */
const SectionHeader = ({ label, sx = {} }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ...sx }}>
      <Typography 
        variant="h6" 
        sx={{ fontWeight: "600 !important", color: '#485869' }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default SectionHeader;
